import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import styles from './ServicesPage.module.css';
import { useLang } from '../../context/LanguageContext';

const SERVICE_HREFS = [
  '/services/sites-web',
  '/services/ia',
  '/services/logiciel',
  '/services/maintenance',
];

const cv = { hidden: { opacity: 0, y: 28 }, visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 } }) };

const ServicesPage = () => {
  const { t } = useLang();
  const sp = t.servicesPage;
  return (
  <div className={styles.page}>

    {/* ── HERO ── */}
    <section className={styles.hero}>
      <div className={styles.dotGrid} />
      <div className={styles.container}>
        <motion.div className={styles.heroContent}
          initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1] }}>
          <span className={styles.tag}>{sp.eyebrow}</span>
          <h1 className={styles.title}>
            {sp.title1}<br />
            <span className={styles.accent}>{sp.title2}</span>
          </h1>
          <p className={styles.sub}>{sp.sub}</p>
        </motion.div>
      </div>
    </section>

    {/* ── SERVICE CARDS ── */}
    <section className={styles.cards}>
      <div className={styles.container}>
        {sp.services.map((s, i) => (
          <motion.div key={i} className={styles.card}
            custom={i} variants={cv} initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-60px' }}>

            <div className={styles.cardLeft}>
              <span className={styles.cardTag}>0{i + 1}</span>
              <h2 className={styles.cardTitle}>{s.title}</h2>
              <p className={styles.cardDesc}>{s.desc}</p>
              <div className={styles.pills}>
                {s.pills.map((pill) => <span key={pill} className={styles.pill}>{pill}</span>)}
              </div>
            </div>

            <div className={styles.cardRight}>
              <Link to={SERVICE_HREFS[i]} className={styles.cardCta}>
                {sp.serviceCta}
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
              </Link>
            </div>
          </motion.div>
        ))}
      </div>
    </section>

  </div>
  );
};

export default ServicesPage;

